import React from 'react';
import { Quest } from '@/services/questService';

interface QuestPanelProps {
  quests: Quest[];
  onMark: (id: string, delta?: number) => void;
  onComplete: (id: string) => void;
}

export const QuestPanel: React.FC<QuestPanelProps> = ({ quests, onMark, onComplete }) => {
  return (
    <div className="bg-black/50 backdrop-blur-md rounded-lg p-4 border border-purple-500/30">
      <h3 className="text-lg font-bold text-purple-300 mb-3">Quests</h3>
      {quests.length === 0 ? (
        <div className="text-sm text-gray-400">No active quests yet.</div>
      ) : (
        <div className="space-y-3">
          {quests.map(q => (
            <div key={q.id} className="p-3 bg-gray-900/50 rounded border border-gray-700">
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-semibold text-cyan-400">{q.title}</div>
                  <div className="text-xs text-gray-400">{q.description}</div>
                </div>
                <div className="text-xs text-gray-300">{q.progress}/{q.required}</div>
              </div>
              <div className="flex gap-2 mt-2">
                <button
                  onClick={() => onMark(q.id, 1)}
                  className="px-2 py-1 text-xs bg-gray-800 hover:bg-gray-700 border border-gray-600 rounded"
                >Mark +1</button>
                <button
                  onClick={() => onComplete(q.id)}
                  className="px-2 py-1 text-xs bg-green-700/40 hover:bg-green-700/60 border border-green-600 rounded"
                >Complete</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default QuestPanel;

